import React from 'react';
import './dot-loader.scss';
function DotLoader() {
 
  return (
    <div className="snippet" data-title=".dot-flashing">
    <div className="stage">
      <div className="dot-flashing"></div>
    </div>
  </div>
  );
}

export default DotLoader;
